import React, { useState, useEffect } from 'react';
import { Box, Typography, Fade } from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import * as API from '../api';
import { formatDistanceToNow } from 'date-fns';
import { vi } from 'date-fns/locale';
import GlobalActivityLogDialog from './GlobalActivityLogDialog';

const ActivityFooter = () => {
    const [latestLog, setLatestLog] = useState(null);
    const [dialogOpen, setDialogOpen] = useState(false);

    const fetchLatest = async () => {
        try {
            // Lấy 1 bản ghi mới nhất
            const res = await API.fetchGlobalActivityLogs({ limit: 1 });
            const data = res.data.results || res.data;
            if (data && data.length > 0) {
                setLatestLog(data[0]);
            }
        } catch (error) {
            console.error("Lỗi polling footer:", error);
        }
    };

    useEffect(() => {
        fetchLatest(); // Gọi ngay khi mount
        
        // Polling: Gọi lại mỗi 30 giây để cập nhật realtime
        const interval = setInterval(fetchLatest, 30000); 
        
        return () => clearInterval(interval);
    }, []);

    if (!latestLog) return null;

    return (
        <>
            <Fade in={true} timeout={1000}>
                <Box 
                    onClick={() => setDialogOpen(true)}
                    sx={{
                        position: 'fixed',
                        bottom: 0,
                        left: 0,
                        width: '100%',
                        height: '32px',
                        bgcolor: '#263238', // Màu tối sang trọng (Dark Blue Grey)
                        color: '#eceff1',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        zIndex: 1300, // Cao hơn các thành phần khác nhưng thấp hơn Modal/Dialog
                        boxShadow: '0px -2px 5px rgba(0,0,0,0.1)',
                        fontSize: '0.8rem',
                        transition: 'background-color 0.3s',
                        '&:hover': {
                            bgcolor: '#37474f'
                        }
                    }}
                >
                    <HistoryIcon sx={{ fontSize: 16, mr: 1, color: '#4db6ac' }} />
                    
                    <Typography variant="caption" sx={{ mr: 1, fontWeight: 'bold', color: '#4db6ac' }}>
                        HOẠT ĐỘNG MỚI NHẤT:
                    </Typography>
                    
                    <Typography variant="caption" sx={{ mr: 2 }}>
                        {latestLog.full_name || 'System'}: {latestLog.description}
                    </Typography>
                    
                    <Typography variant="caption" sx={{ fontStyle: 'italic', color: '#b0bec5' }}>
                        ({formatDistanceToNow(new Date(latestLog.created_at), { addSuffix: true, locale: vi })})
                    </Typography>
                </Box>
            </Fade>

            {/* Popup chi tiết */}
            <GlobalActivityLogDialog 
                open={dialogOpen} 
                onClose={() => setDialogOpen(false)} 
            />
        </>
    );
};

export default ActivityFooter;